import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'La collezione completa in 6 volumi + 5 bonus per insegnare meteorologia in modo chiaro, visivo e pronto per la classe.';
const skyBackdrop = ['radial-gradient(ellipse 55% 22% at 12% 6%, rgba(255,255,255,0.07), transparent 70%)', 'radial-gradient(ellipse 45% 18% at 88% 22%, rgba(255,255,255,0.05), transparent 70%)', 'radial-gradient(ellipse 60% 20% at 20% 52%, rgba(255,255,255,0.04), transparent 70%)', 'radial-gradient(ellipse 50% 18% at 80% 78%, rgba(255,255,255,0.04), transparent 70%)', 'linear-gradient(180deg, #0B1F3A 0%, #12365F 40%, #0F2C50 70%, #0B1F3A 100%)'].join(', ');
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-ink font-sans text-mist antialiased" style={{
    backgroundImage: skyBackdrop
  }} data-id="element-0" data-mp="85l0op2u8u85">
      <MetaPixel data-id="element-1" data-mp="3gm66jx06b771" />
      <main data-id="element-2" data-mp="3glny8208l2ir">
        <Hero data-id="element-3" data-mp="3gj1sm7wwox36" />
        <LookInsideCarousel data-id="element-4" data-mp="3bmbgfvo82ln1" />
        <ProblemSection data-id="element-5" data-mp="3bn314bga6yyj" />
        <SystemSection data-id="element-6" data-mp="3bnuwpm9vowot" />
        <ModulesSection data-id="element-7" data-mp="3bkgqu420a5cm" />
        <BonusSection data-id="element-8" data-mp="3qaxulu2457co" />
        <UrgencySection data-id="element-9" data-mp="3qc966g1svjec" />
        <PricingSection data-id="element-10" data-mp="3qcimfbx1mc6u" />
        <GuaranteeSection data-id="element-11" data-mp="3qd0ud5t2ieul" />
        <FAQ data-id="element-12" data-mp="3ljxukfxp695y" />
        <ClosingSection data-id="element-13" data-mp="3ljg1tta8ud2s" />
        <SummaryTable data-id="element-14" data-mp="3liwgs3par8kj" />
        <FinalCta data-id="element-15" data-mp="3limqef0cazeb" />
      </main>
      <Footer data-id="element-16" data-mp="2xud8ho68yvsg" />
      <PurchaseNotification data-id="element-17" data-mp="2xtv7ke8n3te7" />
    </div>;
}